import React from "react";
import InfoBar from "../InfoBar";
import NotificationContainer from "../notification_balloons/NotificationContainer";

interface PageContainerProps {
  title: string;
  buttons?: React.ReactNode;
  children: React.ReactNode;
}

export default function PageContainer({ title, buttons, children }: PageContainerProps) {
  return (
    <div className="page-container flex flex-col w-full relative dark:bg-ngray">
      <InfoBar />
      <div className="content h-full">
        <div className="main-title bot-gap title-properties rounded flex justify-between items-center dark:bg-nred dark:text-black">
          <h1>{title}</h1>
          <div className="flex justify-between items-center gap-1">
            {buttons}
          </div>
        </div>
        <div className="content-children">
          {children}
        </div>
      </div>
      <NotificationContainer />
    </div>
  );
}